module.exports = __webpack_public_path__ + "img/6.244b2000.jpg";